import { render, staticRenderFns } from "./PricePreview.vue?vue&type=template&id=52db2d4e&"
import script from "./PricePreview.vue?vue&type=script&lang=js&"
export * from "./PricePreview.vue?vue&type=script&lang=js&"
import style0 from "./PricePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports